import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-calendar/dist/Calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';

import { Navigate, Routes, Route } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Context, { AuthContext } from './context/Context';
import { SidebarProvider } from './context/SidebarContext';
import AppLayout from './components/layout/component/AppLayout';

import HomePage1 from './pages';
import ExamPage from './pages/exams';
import ExamsListPage from './pages/exams/list';
import PaymentResultPage from './pages/exams/payment-result';
import SubjectPage from './pages/subjects';
import MaterialsListPage from './pages/materials/list';
import MaterialPage from './pages/materials';
import MockTestsListPage from './pages/mock-tests/list';
import MockTestPage from './pages/mock-tests';
import { ShapeRendering } from './svg/index';
import FooterOne from './components/layout/footers/FooterOne';

import AboutPage1 from './pages/about/about-1';
import AboutPage2 from './pages/about/about-2';

import LoginPage from './pages/others/login';
import UserSettingsPage from './pages/user-settings';
import FreeDownloadsPage from './pages/others/free-downloads';
import PrivacyPolicyPage from './pages/others/privacy-policy';
import SupportPage from './pages/others/support';
import BooksPage from './pages/books';
import AdminPage from './pages/admin';
import ScrollTopBehaviour from './components/common/ScrollTopBehaviour';
import NotFoundPage from './pages/not-found';
import { MessageBoxProvider } from './components/others/MessageBox';
import OTPVerificationGuard from './components/common/OTPVerificationGuard';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 120,
      easing: 'ease-out',
      once: true,
    });
  }, []);
  return (
    <>
      <AuthContext>
        <MessageBoxProvider>
          <Context>
            <SidebarProvider>
              <OTPVerificationGuard>
                <AppLayout 
                  footer={<FooterOne />}
                  shapeRendering={<ShapeRendering />}
                >
                  <Routes>
                  <Route path='/'>
                    <Route index element={<HomePage1 />} />
                    {/* <Route path="volumes/:volumeCode" element={<CourseListPage5 />} /> */}

                    <Route path='exam/:examCode' element={<ExamPage />} />
                    <Route path='exams' element={<ExamsListPage />} />
                    <Route path='materials' element={<MaterialsListPage />} />
                    <Route path='materials/:materialCode' element={<MaterialPage />} />
                    <Route path='mock-tests' element={<MockTestsListPage />} />
                    <Route path='mock-tests/:mockTestCode' element={<MockTestPage />} />
                    <Route path='mock-tests/:mockTestCode/subject/:subjectId' element={<SubjectPage />} />
                    <Route path='payment-result' element={<PaymentResultPage />} />
                    <Route
                      path='exam/:examCode/subject/:subjectId'
                      element={<SubjectPage />}
                    />
                    <Route
                      path='materials/:materialCode/subject/:subjectId'
                      element={<SubjectPage />}
                    />
                    <Route path='about-us' element={<AboutPage1 />} />
                    <Route path='services' element={<AboutPage2 />} />
                    <Route path='books' element={<BooksPage />} />
                    <Route path='admin' element={<AdminPage />} />
                    <Route
                      path='freedownloads'
                      element={<FreeDownloadsPage />}
                    />
                    <Route
                      path='privacy-policy'
                      element={<PrivacyPolicyPage />}
                    />
                    <Route path='support' element={<SupportPage />} />
                    <Route path='not-found' element={<NotFoundPage />} />
                    <Route path='*' element={<NotFoundPage />} />
                    <Route path='login' element={<LoginPage />} />
                    <Route path='signup' element={<Navigate to='/login' replace />} />
                    <Route
                      path='user-settings'
                      element={<UserSettingsPage />}
                    />
                  </Route>
                  </Routes>
                </AppLayout>
                <ScrollTopBehaviour />
              </OTPVerificationGuard>
            </SidebarProvider>
          </Context>
        </MessageBoxProvider>
      </AuthContext>
    </>
  );
}
export default App;
